import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { inputCls, btnPrimary, btnSecondary, Field, ColorPicker } from "@/components/shared";

export const EventDialog = ({ state, onClose, onSaved }) => {
  const [form, setForm] = useState({});
  useEffect(() => {
    if (!state) return;
    const e = state.event;
    setForm(e ? { title: e.title, date: e.date, time: e.time || "", color: e.color, notes: e.notes || "" } : { title: "", date: state.date, time: "", color: "terracotta", notes: "" });
  }, [state]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    if (!form.title?.trim() || !form.date) return;
    const body = { ...form, title: form.title.trim(), time: form.time || null, notes: form.notes || null };
    if (state.event) await api.patch(`/events/${state.event.id}`, body);
    else await api.post("/events", body);
    toast.success(state.event ? "Event updated" : "Event added");
    onSaved();
    onClose();
  };
  const remove = async () => {
    await api.delete(`/events/${state.event.id}`);
    toast("Event deleted");
    onSaved();
    onClose();
  };

  return (
    <Dialog open={!!state} onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="bg-t-bg border-t-line rounded-2xl sm:max-w-lg" data-testid="event-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-3xl font-semibold">{state?.event ? "Edit event" : "New event"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <Field label="Title"><input data-testid="event-title-input" className={inputCls} value={form.title || ""} onChange={set("title")} placeholder="e.g. Dentist appointment" autoFocus /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Date"><input data-testid="event-date-input" type="date" className={inputCls} value={form.date || ""} onChange={set("date")} /></Field>
            <Field label="Time"><input data-testid="event-time-input" type="time" className={inputCls} value={form.time || ""} onChange={set("time")} /></Field>
          </div>
          <Field label="Colour"><ColorPicker value={form.color} onChange={(c) => setForm((f) => ({ ...f, color: c }))} testPrefix="event" /></Field>
          <Field label="Notes"><textarea data-testid="event-notes-input" rows={3} className={inputCls} value={form.notes || ""} onChange={set("notes")} placeholder="Anything to remember..." /></Field>
          <div className="flex gap-3">
            {state?.event && (
              <button type="button" data-testid="event-delete-button" onClick={remove} className={`${btnSecondary} text-t-danger`}><Trash2 className="h-4 w-4" /> Delete</button>
            )}
            <button type="submit" data-testid="event-save-button" className={`${btnPrimary} flex-1`}>Save event</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
